import { render, staticRenderFns } from "./AgendaList.vue?vue&type=template&id=ea183452&scoped=true"
import script from "./AgendaList.vue?vue&type=script&lang=js"
export * from "./AgendaList.vue?vue&type=script&lang=js"
import style0 from "./AgendaList.vue?vue&type=style&index=0&id=ea183452&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea183452",
  null
  
)

export default component.exports